import { BigLoader } from "@circle-react-shared/BigLoader";

export const Loader = ({ title = "", subtitle = "" }) => (
  <div className="my-28">
    <BigLoader subtitle={subtitle} title={title} />
  </div>
);
